module.exports = __webpack_public_path__ + "img/history.c02d5b8c.jpg";